import { Box } from '@chakra-ui/react/box';
import { chakra } from '@chakra-ui/react/styled-system';

import { DecoratedArtifact } from '@/models/Artifact';

interface ImageContentProps {
  artifact: DecoratedArtifact;
  isOpen: boolean;
}

const ImageContent = ({ artifact, isOpen }: ImageContentProps) => {
  const { downloadUrl, title } = artifact;
  return (
    <Box padding="4">
      <chakra.img alt={title} loading="lazy" src={isOpen ? downloadUrl : undefined} />
    </Box>
  );
};

export default ImageContent;
